import { css } from "lit";

export const tableStyles = css`
  .fl-data-table {
    border: 1px solid var(--panel-color);
    border-radius: var(--panel-border-radius);
    overflow: hidden;
  }
  
  .fl-data-table table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
  }
  
  .fl-data-table thead tr {
    background: var(--panel-color);
  }

  .fl-data-table th {
    text-align: left;
    padding: 8px 4px;
  }

  .fl-data-table td {
    padding: 4px;
  }

  .fl-data-table tbody tr:nth-child(even) {
    background: var(--panel-color);
  }

  .fl-data-table tbody tr:hover {
    background: var(--dark-primary);
  }

  .fl-data-table td.actionCell {
    display: flex;
    gap: 6px;
  }

  .fl-data-table .min-width-cell {
    width: 1%;
    white-space: nowrap;
  }

  .fl-scrollable {
    max-height: calc(13 * 40px);
    overflow-y: auto;
  }

  .fl-scrollable th {
    position: sticky;
    top: 0;
    background: var(--panel-color);
  }
`;

export const panelStyles = css`
  .fl-panel {
    padding: 10px;
    margin-bottom: 1em;
  }
`;

export const formStyles = css`
  .fl-form {
    max-width: 600px;
  }
`;

export const linkStyles = css`
  a,
  a:visited {
    color: var(--primary-color);
    text-decoration: none;
  }

  a:hover,
  a:focus-visible {
    text-decoration: underline;
  }

  a:active {
    opacity: 0.85;
  }
`;

export const slTabGroupStyles = css`
  sl-tab-group {
    --indicator-color: var(--secondary-font-color);
  }

  sl-tab::part(base):hover {
    color: var(--secondary-font-color);
  }

  sl-tab[active]::part(base) {
    color: var(--secondary-font-color);
  }
`;

export const slDividerStyles = css`
  sl-divider {
    --color: var(--panel-color);
    --width: 2px;
  }
`;

export const emptyStateStyles = css`
  .fl-empty-message {
    padding: 16px 0;
    color: var(--secondary-font-color);
  }
`;